module.exports = __webpack_public_path__ + "img/right.75abb20c.png";